import { Button } from '@/components/ui/button.js';
import { ApiError } from '@/lib/api/errors.js';

interface CatalogErrorStateProps {
  error: Error;
  onRetry: () => void;
}

export function CatalogErrorState({ error, onRetry }: CatalogErrorStateProps) {
  const requestId = error instanceof ApiError ? error.requestId : undefined;
  const message =
    error instanceof ApiError
      ? error.message
      : 'Error al cargar el catálogo. Por favor, inténtalo de nuevo.';

  return (
    <div role="alert" className="flex flex-col items-center justify-center py-20 text-center">
      <div className="mb-4 text-4xl" aria-hidden="true">
        ⚠️
      </div>
      <h2 className="mb-2 text-lg font-semibold text-[var(--color-qup-text-dark)]">
        Error al cargar el catálogo
      </h2>
      <p className="mb-2 max-w-sm text-sm text-[var(--color-qup-text-muted-dark)]">{message}</p>
      {requestId !== undefined && (
        <p className="mb-6 font-mono text-xs text-[var(--color-qup-text-muted-dark)]">
          ID: {requestId}
        </p>
      )}
      {requestId === undefined && <div className="mb-6" />}
      <Button variant="primary" size="sm" onClick={onRetry}>
        Reintentar
      </Button>
    </div>
  );
}
